module.exports = __webpack_public_path__ + "img/scene4.89c17845.png";